import {
  CreateReimbursementTransactionInput,
  HNAmountInput,
  ReceiptLineItems,
  ReimbursementTransactionStatus,
  ReimbursementTransactionType,
} from 'API';

interface ReimbursementTransactionInputParams {
  paidolId: string;
  transactionDate: string;
  amount: HNAmountInput;
  note?: string | null;
  merchantName?: string | null;
  milesDriven?: number | null;
  purposeOfTrip?: string | null;
  mileageRate?: number | null;
  receiptLineItems: ReceiptLineItems;
  jobCodeId?: string | null;
  procoreProjectId?: number | null;
  procoreWBSCodeId?: number | null;
  transactionType: ReimbursementTransactionType;
  paidolUserId: string;
  expenseTypeId?: string;
  receiptId: string;
  agaveGlCodeId?: string | null;
  agaveProjectId?: string | null;
  agaveCostCodeId?: string | null;
  agaveCostTypeId?: string | null;
  agaveVendorId?: string | null;
  agaveSubJobId?: string | null;
  agaveLocationId?: string | null;
  agaveDepartmentId?: string | null;
  agaveSubaccountId?: string | null;
  agaveEmployeeId?: string | null;
  agaveEquipmentId?: string | null;
  agaveEmCostCodeId?: string | null;
  agaveEmCostTypeId?: string | null;
  codingType?: string | null;
  accountingDate?: string | null;
  flexGlCodeId?: string | null;
  flexCodeId?: string | null;
  flexCostCodeId?: string | null;
  flexCostTypeId?: string | null;
  flexVendorId?: string | null;
  erpBillableItemId?: string | null;
  erpBillableItemName?: string | null;
}

export class ReimbursementTransactionInput implements CreateReimbursementTransactionInput {
  paidolId: string;
  authPaidolId: string;
  transactionDate: string;
  amount: HNAmountInput;
  status: ReimbursementTransactionStatus;
  note?: string | null | undefined;
  merchantName?: string | null | undefined;
  milesDriven?: number | null;
  purposeOfTrip?: string | null;
  mileageRate?: number | null;
  receiptLineItems: ReceiptLineItems;
  jobCodeId?: string | null | undefined;
  procoreProjectId?: number | null | undefined;
  procoreWBSCodeId?: number | null | undefined;
  paidolUserId: string;
  transactionType: ReimbursementTransactionType;
  expenseTypeId?: string;
  receiptId: string;
  agaveGlCodeId?: string | null;
  agaveProjectId?: string | null;
  agaveCostCodeId?: string | null;
  agaveCostTypeId?: string | null;
  agaveVendorId?: string | null;
  agaveSubJobId?: string | null;
  agaveLocationId?: string | null;
  agaveDepartmentId?: string | null;
  agaveSubaccountId?: string | null;
  agaveEmployeeId?: string | null;
  agaveEquipmentId?: string | null;
  agaveEmCostCodeId?: string | null;
  agaveEmCostTypeId?: string | null;
  codingType?: string | null;
  accountingDate?: string | null;
  flexGlCodeId?: string | null;
  flexCodeId?: string | null;
  flexCostCodeId?: string | null;
  flexCostTypeId?: string | null;
  flexVendorId?: string | null;
  erpBillableItemId?: string | null;
  erpBillableItemName?: string | null;

  constructor({
    paidolId,
    transactionDate,
    amount,
    note,
    merchantName,
    milesDriven,
    purposeOfTrip,
    mileageRate,
    receiptLineItems,
    jobCodeId,
    procoreProjectId,
    procoreWBSCodeId,
    transactionType,
    paidolUserId,
    expenseTypeId,
    receiptId,
    agaveGlCodeId,
    agaveProjectId,
    agaveCostCodeId,
    agaveCostTypeId,
    agaveVendorId,
    agaveSubJobId,
    agaveLocationId,
    agaveDepartmentId,
    agaveSubaccountId,
    agaveEmployeeId,
    agaveEquipmentId,
    agaveEmCostCodeId,
    agaveEmCostTypeId,
    codingType,
    accountingDate,
    flexGlCodeId,
    flexCodeId,
    flexCostCodeId,
    flexCostTypeId,
    flexVendorId,
    erpBillableItemId,
    erpBillableItemName,
  }: ReimbursementTransactionInputParams) {
    this.paidolId = paidolId;
    this.authPaidolId = paidolId;
    this.amount = amount;
    this.transactionDate = transactionDate;
    this.note = note;
    this.status = ReimbursementTransactionStatus.REQUESTED;
    this.merchantName = merchantName;
    this.receiptLineItems = receiptLineItems;
    this.paidolUserId = paidolUserId;
    this.transactionType = transactionType;
    this.receiptId = receiptId;
    if (milesDriven != null) this.milesDriven = milesDriven;
    if (purposeOfTrip) this.purposeOfTrip = purposeOfTrip;
    if (mileageRate != null) this.mileageRate = mileageRate;
    if (jobCodeId) this.jobCodeId = jobCodeId;
    if (procoreProjectId) this.procoreProjectId = procoreProjectId;
    if (procoreWBSCodeId) this.procoreWBSCodeId = procoreWBSCodeId;
    if (expenseTypeId) this.expenseTypeId = expenseTypeId;
    if (agaveGlCodeId) this.agaveGlCodeId = agaveGlCodeId;
    if (agaveProjectId) this.agaveProjectId = agaveProjectId;
    if (agaveCostCodeId) this.agaveCostCodeId = agaveCostCodeId;
    if (agaveCostTypeId) this.agaveCostTypeId = agaveCostTypeId;
    if (agaveVendorId) this.agaveVendorId = agaveVendorId;
    if (agaveSubJobId) this.agaveSubJobId = agaveSubJobId;
    if (agaveLocationId) this.agaveLocationId = agaveLocationId;
    if (agaveDepartmentId) this.agaveDepartmentId = agaveDepartmentId;
    if (agaveSubaccountId) this.agaveSubaccountId = agaveSubaccountId;
    if (agaveEmployeeId) this.agaveEmployeeId = agaveEmployeeId;
    if (agaveEquipmentId) this.agaveEquipmentId = agaveEquipmentId;
    if (agaveEmCostCodeId) this.agaveEmCostCodeId = agaveEmCostCodeId;
    if (agaveEmCostTypeId) this.agaveEmCostTypeId = agaveEmCostTypeId;
    if (codingType) this.codingType = codingType;
    if (accountingDate) this.accountingDate = accountingDate;
    if (flexGlCodeId) this.flexGlCodeId = flexGlCodeId;
    if (flexCodeId) this.flexCodeId = flexCodeId;
    if (flexCostCodeId) this.flexCostCodeId = flexCostCodeId;
    if (flexCostTypeId) this.flexCostTypeId = flexCostTypeId;
    if (flexVendorId) this.flexVendorId = flexVendorId;
    if (erpBillableItemId) this.erpBillableItemId = erpBillableItemId;
    if (erpBillableItemName) this.erpBillableItemName = erpBillableItemName;
  }
}
